import styled from "styled-components";
import { colors } from "../../../styles/figmaColors";
import { SpinnerDS } from "./SpinnerDS";

interface LoaderOverlayProps {
  visible: boolean;
  size?: number;
}

/**
 * Semi-transparent overlay centering a SpinnerDS, used to keep the user
 * waiting during a request (e.g. inside a modal's children).
 *
 * Positioned with `absolute`: the direct parent must be positioned
 * (`position: relative`) so the overlay only covers that area.
 */
export const LoaderOverlay = (props: LoaderOverlayProps) => {
  if (!props.visible) {
    return null;
  }
  return (
    <StyledOverlay>
      <SpinnerDS size={props.size} />
    </StyledOverlay>
  );
};

const StyledOverlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${colors["colors/surfaces/background/background_level0"]};
  opacity: 0.7;
`;
